<script lang="ts">
    import background from 'src/components/main/games/components/audience/background.svg'
    import backgroundMobile from 'src/components/main/games/components/audience/audience-mobile.svg'
    import games from 'src/components/main/games/components/audience/cards.png'
    import {api} from 'src/services/api/reallis'

    let audience = getAudience()

    async function getAudience() {
        let result = await api.ws.ws1.request({
            data: {
                agent: "user",
                auth: {type: "webSite"},
                lang: "en",
                method: "profile_getNum",
                params: {}
            }
        })
        return (result.result.response.value - result.result.response.value % 1000).toLocaleString()
    }
</script>

<section class="audience" style="
        --background: url({background});
        --backgroundMobile: url({backgroundMobile})
    ">
    <div class="container">
        <div class="title">The audience of our games is more than</div>
        <div class="count">
            {#await audience}
                Loading...
            {:then count}
                {count}+
            {/await}
        </div>
        <div class="description">Players around the world</div>
        <a href="https://play.google.com/store/apps/dev?id=5329690909234469933" class="google-play-link" target="_blank">
            <img src="{games}" class="image" alt="games">
        </a>
    </div>
</section>

<style>
    .audience {
        background: var(--background) no-repeat center;
        padding: 500px 0 350px;
        margin: -350px 0 -100px;
    }

    .title {
        text-align: center;
        font-family: 'Anton', sans-serif;
        font-size: 50px;
        line-height: normal;
        color: #CED5E3;
    }

    .count {
        color: white;
        text-align: center;
        font-family: 'Anton', sans-serif;
        font-size: 220px;
        line-height: normal;
        margin: 30px 0;
        -webkit-text-stroke-color: #dc6037;
        -webkit-text-stroke-width: 5px;
        letter-spacing: 10px;
    }

    .description {
        text-align: center;
        font-family: 'Anton', sans-serif;
        font-size: 50px;
        line-height: normal;
        color: #CED5E3;
        margin-bottom: 100px;
    }

    .image {
        display: block;
        margin: 0 auto;
    }

    @media(max-width: 1400px) {
        .audience {
            padding: 300px 0 250px;
            margin: -200px 0 -100px;
        }

        .title {
            font-size: 46px;
        }

        .count {
            font-size: 190px;
        }

        .description {
            font-size: 46px;
        }
    }

    @media(max-width: 1199px) {
        .audience {
            padding: 300px 0 180px;
        }

        .image {
            max-width: 630px;
        }

        .title {
            font-size: 36px;
        }

        .count {
            font-size: 150px;
        }

        .description {
            font-size: 36px;
        }
    }

    @media(max-width: 991px) {
        .audience {
            padding: 200px 0 180px;
            background-size: cover;
        }

        .title {
            font-size: 30px;
        }

        .count {
            font-size: 120px;
            margin: 20px 0;
            -webkit-text-stroke-width: 4px;
        }

        .description {
            font-size: 30px;
        }

        .image {
            max-width: 550px;
        }
    }

    @media(max-width: 767px) {
        .audience {
            background: var(--backgroundMobile) no-repeat center right;
            padding: 75px 0 220px;
            background-size: 90%;
            margin: -120px 0 -120px;
        }

        .title {
            font-size: 20px;
        }

        .count {
            font-size: 70px;
            -webkit-text-stroke-width: 3px;
            letter-spacing: 5px;
        }

        .description {
            font-size: 20px;
            margin-bottom: 40px;
        }

        .image {
            max-width: 100%;
        }
    }

    @media(max-width: 370px) {
        .count {
            font-size: 60px;
        }
    }
</style>
